class ChangeStyleActionType {
    static loadGarments = {
        start: 'COMPONENT_CHANGE_GARMENT_STYLE_LOAD_GARMENTS_START',
        success: 'COMPONENT_CHANGE_GARMENT_STYLE_LOAD_GARMENTS_SUCCESS',
        fail: 'COMPONENT_CHANGE_GARMENT_STYLE_LOAD_GARMENTS_FAIL',
        reset: 'COMPONENT_CHANGE_GARMENT_STYLE_LOAD_GARMENTS_RESET',
    };
}

export default ChangeStyleActionType;
